import { HiCursorClick } from "react-icons/hi";
import { FaKeyboard } from "react-icons/fa";
import DefaultWebcam from "../../medias/images/noCamshot.jpg";
import DefaultScreenshot from "../../medias/images/noScreenshot.jpg";
import { useEffect, useMemo, useState } from "react";
import "./TimeCardModal.css";
import { requestGetImagesFromBucket } from "../../services/wisdomServices/trackingService";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { SlScreenDesktop } from "react-icons/sl";
import { FaTableColumns } from "react-icons/fa6";

function TimeCardModal(props) {
  const [screenshot, setScreenshot] = useState(DefaultScreenshot);
  const [webcam, setWebcam] = useState(DefaultWebcam);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewTitle, setPreviewTitle] = useState("");

  const productivityColor = useMemo(() => {
    const p = (props.productivityType || "").toLowerCase();

    if (p === "productive") return "#3CBE52";
    if (p === "overtime") return "#fcd257";
    if (p === "rejected" || p === "otdiscard") return "#C34D57";
    if (p === "markasactive") return "#F1C40F";
    if (p === "manualtime") return "#5669E1";
    if (p === "idle") return "#808080";

    return "#802112";
  }, [props.productivityType]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") props.onCancel();
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [props.onCancel]);

  useEffect(() => {
    let screenshotUrl;
    let webcamUrl;

    (async () => {
      try {
        const [screenshotBlob, webcamBlob] = await Promise.all([
          props.screensrc === "default"
            ? Promise.resolve(DefaultScreenshot)
            : requestGetImagesFromBucket(
                props.userId,
                props.screensrc,
                "screenshot"
              ),

          props.camsrc === "default"
            ? Promise.resolve(DefaultWebcam)
            : requestGetImagesFromBucket(props.userId, props.camsrc, "webcam"),
        ]);

        screenshotUrl =
          screenshotBlob instanceof Blob
            ? URL.createObjectURL(screenshotBlob)
            : screenshotBlob;

        webcamUrl =
          webcamBlob instanceof Blob
            ? URL.createObjectURL(webcamBlob)
            : webcamBlob;

        setScreenshot(screenshotUrl);
        setWebcam(webcamUrl);
      } catch {
        setScreenshot(DefaultScreenshot);
        setWebcam(DefaultWebcam);
      }
    })();

    return () => {
      if (screenshotUrl) URL.revokeObjectURL(screenshotUrl);
      if (webcamUrl) URL.revokeObjectURL(webcamUrl);
    };
  }, [props.screensrc, props.camsrc, props.userId]);

  const openPreview = (image, title) => {
    const isScreenshot = title === "Screenshot";

    const previewHeader = isScreenshot
      ? `Screenshot - ${props.appInUse || "-"} - ${props.tabInUse || "-"}`
      : title;

    setPreviewImage(image);
    setPreviewTitle(previewHeader);
    setPreviewVisible(true);
  };

  const statusTemplate = (option) => {
    switch ((option || "").toLowerCase()) {
      case "productive":
        return "Productive";
      case "overtime":
        return "Overtime";
      case "rejected":
        return "Rejected";
      case "markasactive":
        return "Marked as Active";
      case "manualtime":
        return "Manual Time";
      case "idle":
        return "Idle";
      default:
        return option;
    }
  };

  return (
    <div className="time-card-modal">
      <div className="timecard-header">
        <div className="timecard-header-title">
          <h3>
            Time Card Details{" "}
            <span>
              {props.date} {props.activityTime} | {props.project}
            </span>
          </h3>
        </div>

        <div className="timecard-header-actions">
          <div
            className="productivity-status-card"
            style={{ backgroundColor: productivityColor }}
          >
            {statusTemplate(props.productivityType || "Unknown")}
          </div>

          <Button
            type="button"
            className="timecard-close-button"
            icon="pi pi-times"
            onClick={props.onCancel}
            aria-label="Close modal"
          />
        </div>
      </div>

      <div className="timecard-content-grid">
        <div className="timecard-image-wrapper screenshot-wrapper">
          <img
            src={screenshot}
            alt="Screenshot"
            onClick={() => openPreview(screenshot, "Screenshot")}
            className="clickable-image"
          />
        </div>

        <div className="timecard-image-wrapper webcam-wrapper">
          <img
            src={webcam}
            alt="Webcam"
            onClick={() => openPreview(webcam, "Webcam")}
            className="clickable-image"
          />
        </div>

        <div className="timecard-details-row">
          <div className="timecard-info-item metric-item">
            <SlScreenDesktop />
            
            <div>
              <span>Application</span>
              <strong>{props.appInUse || "-"}</strong>
            </div>
          </div>

          <div className="timecard-info-item metric-item">
            <FaTableColumns />

            <div>
              <span>Tab</span>
              <strong title={props.tabInUse}>{props.tabInUse || "-"}</strong>
            </div>
          </div>

          <div className="timecard-info-item metric-item">
            <HiCursorClick />

            <div>
              <span>Mouse Clicks</span>
              <strong>{props.mouse}</strong>
            </div>
          </div>

          <div className="timecard-info-item metric-item">
            <FaKeyboard />

            <div>
              <span>Key Strokes</span>
              <strong>{props.keys}</strong>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        header={previewTitle}
        visible={previewVisible}
        onHide={() => setPreviewVisible(false)}
        maximizable
        draggable={false}
        style={{ width: "90vw" }}
        className="timecard-preview-dialog"
        contentStyle={{
          padding: 0,
          background: "#000",
        }}
      >
        <img
          src={previewImage}
          alt={typeof previewTitle === "string" ? previewTitle : "Preview"}
          style={{
            width: "100%",
            maxHeight: "85vh",
            objectFit: "contain",
            display: "block",
          }}
        />
      </Dialog>
    </div>
  );
}

export default TimeCardModal;